import React, { useReducer, useContext } from "react";
import { teamTopicReducer as reducer } from "../reducers/teamTopicReducer";
import { teamTopicActions as actions } from "../actions/teamTopicActions";

const teamTopicContext = React.createContext();

const TeamTopicContext = ({ team, children }) => {
  const initialValue = {
    team: team,
    topics: null,
  };

  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <teamTopicContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </teamTopicContext.Provider>
  );
};

export const useTeamTopicContext = () => React.useContext(teamTopicContext);
export default TeamTopicContext;
